export default "__VITE_ASSET__CW_avyj3__"